import { ModeratedOfferInput } from './moderated-offer-input';

export class ModeratedOffers {
  offers: Array<ModeratedOfferInput> = [];
  approverComment: string;
  showYom: boolean = false;
  showYor: boolean = false;
}
